export default "__VITE_ASSET__C5PakKG5__"